import axios from 'axios'
import {createSlice, createAsyncThunk, PayloadAction} from '@reduxjs/toolkit'
const api = '/api/'

export const relativeList = createAsyncThunk(
  'tools/relative-list',
  async (params: any, thunkAPI) => {
    try {
      const {data} = await axios.get(`${api}tools/relative-list`, params)
      return data
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response?.data?.errors)
    }
  }
)

export const relativeStore = createAsyncThunk(
  'tools/relative-store',
  async (subjectData: any, thunkAPI) => {
    try {
      const {data} = await axios.post(`${api}tools/relative-store`, subjectData)
      return data
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response?.data?.errors)
    }
  }
)

export const relativeEdit = createAsyncThunk('tools/relative-edit', async (id: any, thunkAPI) => {
  try {
    const {data} = await axios.get(`${api}tools/relative-edit/${id}`)
    return data
  } catch (error: any) {
    return thunkAPI.rejectWithValue(error.response?.data?.errors)
  }
})

type ToolsState = {
  errors: any
}

const initialState: ToolsState = {
  errors: '',
}

export const toolsSlice = createSlice({
  name: 'tools',
  initialState,
  reducers: {
    reset: () => initialState,
  },
  extraReducers: (builder) => {
    builder.addCase(relativeStore.rejected, (state, action: PayloadAction<any>) => {
      state.errors = action.payload
    })
  },
})

export const {reset} = toolsSlice.actions
export default toolsSlice.reducer
